export const isAuthenticated = () => {
  return localStorage.getItem('userId') !== null;
};

export const loginUser = (token, userId) => {
  localStorage.setItem('authToken', token);
  localStorage.setItem('userId', userId);
};

export const logoutUser = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('userId');
  window.location.href = '/login';
};

// Get stored user ID
export const getUserId = () => {
  return localStorage.getItem('userId');
};
